<template>
    <div>
        <dataTable :table="users_requests_table" type="user_requests" :filter="obj" />
        <v-layout v-if="request_pages>1 || obj.page_size != 10" align-center wrap
                  :class="{'px-3': $vuetify.breakpoint.xs, 'mt-4 justify-center': $vuetify.breakpoint.smAndDown, 'mt-5 justify-end': $vuetify.breakpoint.mdAndUp}"
        >
            <v-flex md5 sm7 xs12>
                <div class="text-xs-center">
                    <v-pagination
                        v-model="pagination"
                        :length="request_pages"
                        :total-visible="$vuetify.breakpoint.xs ? 4 : 6"
                        prev-icon="arrow_back_ios"
                        next-icon="arrow_forward_ios"
                    />
                </div>
            </v-flex>
            <v-flex md4 sm6 :class="{'mt-4': $vuetify.breakpoint.smAndDown}">
                <v-select
                    :items="$vuetify.breakpoint.mdAndUp ? [$t('Показывать по 10'),$t('Показывать по 25'),$t('Показывать по 50'),$t('Показывать по 100')]
                    : [$t('Показывать по 10'),$t('Показывать по 25'),$t('Показывать по 50')]"
                    solo
                    append-icon=""
                    :label="$t('Показывать по 10')"
                    class="input"
                    @change="set_page_size({selected:$event, type: 'user'})"
                >
                  <template #append>
                    <v-icon aria-hidden="true" translate="no">
                      expand_more
                    </v-icon>
                  </template>
                </v-select>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
import dataTable from '../Users_table';
import {mapGetters, mapMutations, mapActions} from 'vuex';
export default {
  components: {
    dataTable,
  },
  data() {
    return {
      requests: '',
      obj     : {
        page_size: 10,
        page_num : 1,
      },
    };
  },
  computed: {
    ...mapGetters('users', [
      'tab',
      'showed_filter',
    ]),
    ...mapGetters('users/modals', [
      'add_user',
      'add_organization',
    ]),
    ...mapGetters('users/requests', [
      'users_requests_table',
      'user_request_forms',
      'request_type',
      'request_pages',
      'page',
    ]),
    pagination: {
      get() {
        return this.page;
      },
      set($event) {
        this.SET_PAGE({page: $event, type: 'user'});
        this.obj.page_num = $event;
        this.get_users_requests(this.obj);
        return;
      },
    },
  },
  mounted() {
    this.obj = {
      page_size: 10,
      page_num : 1,
      by       : '',
      order    : '',
    };
    this.get_users_requests(this.obj);
    this.requests = this.users_requests_table;
    this.filter_requests();

    this.$root.$on('users_req_updated', async () => {
      await this.get_users_requests(this.obj);
      this.requests = this.users_requests_table;
      this.filter_requests();
    });
  },
  methods: {
    filter_requests() {
      let req = this.requests.content.body.map((item, index, arr)=>{
        return item = {
          'name'        : item.name,
          'request_type': 'Сотрудник',
          'initiator'   : item.request_by,
          'date'        : item.date,
        };
      });
      // this.requests.content.body = req;
    },
    set_page_size(value) {
      let {selected, type} = value;
      this.obj.page_size = Number(selected.slice(-3));
      this.SHOW_NUMBER(value);
      this.get_users_requests(this.obj);
    },
    ...mapMutations('users', [
      'SET_ACTIVE_TAB',
      'TOGGLE_FILTER',
    ]),
    ...mapMutations('users/requests', [
      'SET_PAGE',
      'SHOW_NUMBER',
    ]),
    ...mapActions('users/requests', [
      'get_users_requests',
    ]),
    ...mapMutations('users/modals', [
      'OPEN_MODAL',
      'CLOSE_MODAL',
    ]),
  },
};
</script>
